import React from "react";
import styled from "styled-components";

import { LinkButtonProps } from "./button.type";
import BaseButton from "./BaseButton";
import { oldIconMapper } from "./iconMapper.old";
import Icon from "../Icon/Icon";

const StyledLinkButton = styled(BaseButton)<LinkButtonProps>`
  text-decoration: none;
`;

const LinkButton = React.forwardRef<HTMLAnchorElement, LinkButtonProps>(
  (
    {
      id,
      text,
      children,
      paddingX = 9,
      link,
      shouldOpenInNewWindow = true,
      variant = "primary",
      icon,
      iconWeight = "regular",
      iconAlignment = "left",
      iconColor = "currentColor",
      iconWidth,
      iconHeight,
      width,
      analytics,
      ...props
    },
    ref
  ) => {
    const linkTarget = shouldOpenInNewWindow ? "_blank" : "_top";
    const mappedIcon = icon ? oldIconMapper[icon] ?? icon : undefined;
    const eventName = analytics ? "click" : undefined;
    const eventCategory = analytics
      ? analytics.eventCategory || "button"
      : undefined;
    return (
      <StyledLinkButton
        id={id}
        variant={variant}
        as="a"
        href={link}
        target={linkTarget}
        paddingX={paddingX}
        width={width}
        /* @ts-ignore */
        ref={ref}
        data-en={eventName}
        data-ec={eventCategory}
        data-el={analytics?.eventLabel}
        data-ea={analytics?.eventAction}
        data-es={analytics?.eventSection}
        data-et={analytics?.eventType}
        data-ev={analytics?.eventValue}
        {...props}
      >
        {iconAlignment === "left" && mappedIcon !== undefined && (
          <Icon
            name={mappedIcon?.name || icon}
            weight={mappedIcon?.weight || iconWeight}
            color={iconColor}
            mr={2}
            width={iconWidth || mappedIcon?.width}
            height={iconHeight || mappedIcon?.height}
          />
        )}
        {text}
        {children}
        {iconAlignment === "right" && mappedIcon !== undefined && (
          <Icon
            name={mappedIcon?.name || icon}
            weight={mappedIcon?.weight || iconWeight}
            color={iconColor}
            ml={6}
            width={iconWidth || mappedIcon?.width}
            height={iconHeight || mappedIcon?.height}
          />
        )}
      </StyledLinkButton>
    );
  }
);

export default LinkButton;
